import React from "react";
import type { JSX } from "react";

import cn from "classnames";

import { boxForwardRef } from "../../../../../helpers/common/Box/Box";
import { Text } from "../../../../Text";

import type { BoxComponentWithDefault } from "../../../../../helpers/common/Box/Box";
import type { TextProps } from "../../../../Text";
import type { TagSizes } from "../../types";

import classes from "./TagLabel.styl";

const TAG_LABEL_TEST_ID = "tag-label-test-id";

export type TagLabel = Omit<
    TextProps,
    | "typographyStyle"
    | "maxLines"
    | "truncateStyle"
    | "textCase"
    | "underline"
    | "strikethrough"
    | "lineHeight"
    | "asList"
    | "quote"
    | "italic"
> & { size?: TagSizes };

export const TagLabel = boxForwardRef<
    BoxComponentWithDefault<"span", TagLabel, "className">
>(({ size, customVarsStyles, children, ...props }, ref): JSX.Element | null => {
    return children ? (
        <Text
            data-tsid={TAG_LABEL_TEST_ID}
            {...props}
            typographyStyle={size === "20" ? "caption-s" : "caption-m"}
            maxLines={1}
            customVarsStyles={cn(
                classes["custom-vars-styles"],
                customVarsStyles,
            )}
            ref={ref}
        >
            {children}
        </Text>
    ) : null;
});

TagLabel.displayName = "Tag.Label";

export default TagLabel;
